import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';

import { InputCustomField } from './InputCustomField.entity';

export class InputVerteiler<T extends EMode = EMode.entity> {
  /** Alias: code */
  code?: number;
  /** Alias: name */
  name?: string;
  /** Alias: position */
  position?: number;
  /** Alias: verteilerKlassenCode */
  verteilerKlassenCode?: number;
  /** Alias: grCode */
  grCode?: number;
  /** Alias: verteilerNummer */
  verteilerNummer?: number;
  /** Alias: personenverteiler */
  personenverteiler?: boolean;
  /** Alias: firmenverteiler */
  firmenverteiler?: boolean;
  /** Alias: benutzerCode */
  benutzerCode?: number;
  /** Alias: artikelverteiler */
  artikelverteiler?: boolean;
  /** Alias: auftragsverteiler */
  auftragsverteiler?: boolean;
  /** Alias: lookupCode */
  lookupCode?: number;
  /** Alias: standardKunde */
  standardKunde?: boolean;
  /** Alias: standardLieferant */
  standardLieferant?: boolean;
  /** Alias: hide */
  hide?: boolean;
  /** Alias: updateTime */
  updateTime?: string;
  /** Alias: insertTime */
  insertTime?: string;
  /** Alias: customFields */
  customFields?: InputCustomField<T>[];

  __typename?: string;
}

const fields: FieldDefinitions<InputVerteiler> = {
  code: {
    alias: 'code',
  },
  name: {
    alias: 'name',
  },
  position: {
    alias: 'position',
  },
  verteilerKlassenCode: {
    alias: 'verteilerKlassenCode',
  },
  grCode: {
    alias: 'grCode',
  },
  verteilerNummer: {
    alias: 'verteilerNummer',
  },
  personenverteiler: {
    alias: 'personenverteiler',
  },
  firmenverteiler: {
    alias: 'firmenverteiler',
  },
  benutzerCode: {
    alias: 'benutzerCode',
  },
  artikelverteiler: {
    alias: 'artikelverteiler',
  },
  auftragsverteiler: {
    alias: 'auftragsverteiler',
  },
  lookupCode: {
    alias: 'lookupCode',
  },
  standardKunde: {
    alias: 'standardKunde',
  },
  standardLieferant: {
    alias: 'standardLieferant',
  },
  hide: {
    alias: 'hide',
  },
  updateTime: {
    alias: 'updateTime',
  },
  insertTime: {
    alias: 'insertTime',
  },
  customFields: {
    alias: 'customFields',
  },
  __typename: {
    alias: '__typename',
  },
};

export const inputVerteilerEntityDefinition: EntitiyDefinition<InputVerteiler> =
  {
    local: {},
    remote: {
      queryName: '',
      fragmentName: 'InputVerteiler',
      withPaginationWrapper: false,
    },
    fieldDefinitions: fields,
  };
